import * as React from 'react';

import {Modal} from 'shells/modal/modal';
import {StatusHeader} from 'shells/status-button/status-header';

import {useSetGoogleCalendarSyncIsEnabled} from '../../setup/calendar/graphql/hooks/use-set-google-calendar-sync-is-enabled';
import {useSetOffice365CalendarSyncIsEnabled} from '../../setup/calendar/graphql/hooks/use-set-office365-calendar-sync-is-enabled';

import {CalendarOnboardingModal} from '../calendar/calendar-onboarding-modal';
import {CalendarReconnectOnboardingModal} from '../calendar/calendar-reconnect-onboarding-modal';
import {EnableCalendar} from '../calendar/enable-calendar';
import {getFlashBannerType, getStatusDescription, getStatusIcon} from '../calendar/helpers';

import styles from './calendar-modal-component.module.css';

type Props = {
    errorMessage: string | null | undefined;
    calendarSync: any;
    isLoading: boolean;
    refetch: () => Promise<any>;
    onClose: () => void;
    onSuccess?: () => any;
};

export function CalendarModalComponent(props: Props) {
    const {setGoogleCalendarSyncIsEnabled} = useSetGoogleCalendarSyncIsEnabled();
    const {setOffice365CalendarSyncIsEnabled} = useSetOffice365CalendarSyncIsEnabled();

    if (props.errorMessage) {
        return (
            <CalendarReconnectOnboardingModal
                calendarSync={props.calendarSync}
                isLoading={props.isLoading}
                refetchSyncStatus={props.refetch}
                onClose={props.onClose}
            />
        );
    }

    if (!props.calendarSync) {
        return (
            <CalendarOnboardingModal
                calendarSync={props.calendarSync}
                isLoading={props.isLoading}
                refetchSyncStatus={props.refetch}
                onSuccess={props.onSuccess}
                onClose={props.onClose}
            />
        );
    }

    if (props.calendarSync && !props.calendarSync.isEnabled) {
        return (
            <Modal
                isOpen={true}
                onClose={props.onClose}
                noPadding={true}
                closeButton={false}
                maxHeight={180}
                maxWidth={400}
            >
                <StatusHeader
                    type={getFlashBannerType(props.calendarSync) || 'info'}
                    icon={getStatusIcon(props.calendarSync)}
                    content={getStatusDescription(props.calendarSync)}
                />
                <div className={styles['enable-calendar']}>
                    <EnableCalendar
                        status={props.calendarSync}
                        refetchSyncStatus={props.refetch}
                        windowFeatures={{
                            toolbar: 'no',
                            location: 'no',
                            width: 600,
                            height: 850,
                        }}
                        setGoogleCalendarSyncIsEnabled={setGoogleCalendarSyncIsEnabled}
                        setOffice365CalendarSyncIsEnabled={setOffice365CalendarSyncIsEnabled}
                        onSuccess={props.onSuccess}
                    />
                </div>
            </Modal>
        );
    }

    return <></>;
}
